define('tinymce-post',['tinymce-base',
		'tinymce-plugins/table/classes/Plugin',
		'tinymce-plugins/wa5_image/plugin',
		'tinymce-plugins/wa5_image_cropping/plugin',
		'tinymce-plugins/hr/plugin',
		'tinymce-plugins/textcolor/plugin',
		'tinymce-plugins/charmap/plugin',
		'tinymce-plugins/wa5_headings/plugin',
		'tinymce-plugins/wa5_math/plugin',
		'tinymce-plugins/wa5_fixbreak/plugin',
		'tinymce-plugins/wa5_tableresize/plugin',
		'tinymce/pasteplugin/Plugin'], function(tinymce) {
	// this module will seem to be loaded even if the plugins are still loading
	// if possible, this should be fixed as it is a race condition.
	// the problem is that some plugins depend on window.tinymce being set,
	// and that is not the case if we just put them side-to-side in a define()
	// requirements list
	
	return tinymce;
});

